import React from 'react';
import Form from './Form';
import { FaFacebook, FaGithub, FaLinkedin } from 'react-icons/fa';
import { Link } from 'react-router-dom';
const Contact = () => {
    return (
        <div id="contact" className="grid grid-cols-1 lg:grid-cols-2 w-10/12 items-center py-4 mx-auto bg-transparent filter drop-shadow-2xl">

            <div className="w-11/12 mx-auto mb-8">
                <h2 className="text-white text-4xl font-concertone my-8">Get In Touch</h2>
                <p className="text-gray-400 text-left text-md font-poppins">Feel free to get in touch with me. I am always open to discssing new projects, creative ideas or get ideas opportunities to be part of your open visions. </p>
                <div className="w-10/12 lg:w-6/12 mx-auto py-4 mt-8 flex row justify-evenly 
                rounded-full border-2 border-white text-gray-500
                ">
                    <a target="_blank" href="https://www.linkedin.com/in/shudipta-das-8645241a9/">
                        <FaLinkedin className="text-4xl hover:text-white" />
                    </a>
                    <a target="_blank" href="https://github.com/shudiptod">
                        <FaGithub className="text-4xl hover:text-white" />
                    </a>
                    <a target="_blank" href="https://www.facebook.com/shudipto.shupto.das/">
                        <FaFacebook className="text-4xl hover:text-white" />
                    </a >

                </div>
            </div>
            <div className="w-11/12 mx-auto bg-black">
                <h2 className="text-white text-4xl font-caveat my-8 mb-4">Contact Me</h2>
                <Form />
            </div>
        </div>
    );
};

export default Contact;